import styled from 'styled-components';

export const StyledHomeQuestionCompleteContent = styled.div.attrs(props => ({
  className: props.className
}))`
    padding: 76px 0;
    .pageTitle{
        font-size: 24px;
        font-weight:500;
    }
    .hint{
        text-align: center;
        color: ${({ theme }) => theme.colors.text.text_06};
        span{
            color: #4C99A5;
            border-bottom: 1px solid #4C99A5;
            cursor: pointer;
        }
        @media (max-width: 1024px) {
            text-align: center;
        }
    }
    > div{
        display: flex;
        justify-content: center;
    }
    .titleRow{
        text-align: center;
    }
    .textRow{
        text-align: center;
    }
    .load-wrapp {
        width: 100px;
    }
    .bar {
        float: left;
        width: 15px;
        height: 4px;
        border-radius: 4px;
        background-color: ${({ theme }) => theme.colors.ui.ui_04};
    }

    .load-10 .bar {
        animation: loadingJ 2s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
    }
    .fixedBottomBox{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .btnBox{
        display: flex;
        >div{
            width: 120px;
            padding: 11px 16px;
            border: 1px solid ${({ theme }) => theme.colors.brand.brand01};
            color: ${({ theme }) => theme.colors.brand.brand01};
            border-radius: 4px;
            &:not(:last-child){
                margin-right: 12px;
            }
            >svg{
                font-size: 16px;
            }
            @media (max-width: 1024px){
                width: 50%;
            }
        }
    }

    .controlBtnBox{
        >div{
            width: 252px;
            padding: 12px 16px;
            @media (max-width: 1024px){
                width: 100%;
            }
        }
    }

    @keyframes loadingJ {
        0%,
        100% {
            transform: translate(0, 0);
        }

        50% {
            transform: translate(80px, 0);
            
            width: 30px;
        }
    }
    @media (max-width: 1024px) {
        .fixedBottomBox{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 1003;
            background-color: #fff;
            padding: 8px 24px 35px 24px;
            box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05);
            >div{
                width: 100%;
            }
        }
    }
`;